import { render, staticRenderFns } from "./DimensionModal.vue?vue&type=template&id=10c8dc44"
import script from "./DimensionModal.vue?vue&type=script&lang=js"
export * from "./DimensionModal.vue?vue&type=script&lang=js"
import style0 from "./DimensionModal.vue?vue&type=style&index=0&id=10c8dc44&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports